/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MissingTitularReportRowDTO
 */
export interface MissingTitularReportRowDTO {
    /**
     * 
     * @type {string}
     * @memberof MissingTitularReportRowDTO
     */
    programName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MissingTitularReportRowDTO
     */
    facultyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MissingTitularReportRowDTO
     */
    domainName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MissingTitularReportRowDTO
     */
    planCadru?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MissingTitularReportRowDTO
     */
    disciplineName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MissingTitularReportRowDTO
     */
    disciplineCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MissingTitularReportRowDTO
     */
    studyYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MissingTitularReportRowDTO
     */
    semester?: string | null;
}

export function MissingTitularReportRowDTOFromJSON(json: any): MissingTitularReportRowDTO {
    return MissingTitularReportRowDTOFromJSONTyped(json, false);
}

export function MissingTitularReportRowDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MissingTitularReportRowDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programName': !exists(json, 'programName') ? undefined : json['programName'],
        'facultyName': !exists(json, 'facultyName') ? undefined : json['facultyName'],
        'domainName': !exists(json, 'domainName') ? undefined : json['domainName'],
        'planCadru': !exists(json, 'planCadru') ? undefined : json['planCadru'],
        'disciplineName': !exists(json, 'disciplineName') ? undefined : json['disciplineName'],
        'disciplineCode': !exists(json, 'disciplineCode') ? undefined : json['disciplineCode'],
        'studyYear': !exists(json, 'studyYear') ? undefined : json['studyYear'],
        'semester': !exists(json, 'semester') ? undefined : json['semester'],
    };
}

export function MissingTitularReportRowDTOToJSON(value?: MissingTitularReportRowDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'programName': value.programName,
        'facultyName': value.facultyName,
        'domainName': value.domainName,
        'planCadru': value.planCadru,
        'disciplineName': value.disciplineName,
        'disciplineCode': value.disciplineCode,
        'studyYear': value.studyYear,
        'semester': value.semester,
    };
}

